import React from "react";
import { Api } from "../../../api";
import { hasError } from "../../../helpers/ResponseHelper";
import MaterialTable from "material-table";
import TableSearch from "../../Table/TableSearch";
import { useHistory } from "react-router-dom";
import { Training } from "../../../types/Training";
import CloseIcon from "@material-ui/icons/Close";
import {
  Button,
  Chip,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  DialogActions,
  makeStyles
} from "@material-ui/core";
import MoreButton from "../../MoreButton";
import { CompanyContext } from "../../../context/CompanyContext";
import { useSnackbar } from "notistack";

interface IProps {
  groupId: string;
}

export default function AdminGroupDetailsAssignments(props: IProps) {
  const classes = useStyles();
  const { groupId } = props;
  const [training, setTraining] = React.useState<Training[]>([]);
  const [loading, setLoading] = React.useState(false);
  const history = useHistory();
  const companyContext = React.useContext(CompanyContext);
  const [assignmentIds, setAssignmentIds] = React.useState(Array<string>());
  const { enqueueSnackbar } = useSnackbar();
  const [trainingId, setTrainingId] = React.useState("")
  const [showDeleteConfirmation, setShowDeleteConfirmation] = React.useState(false);

  const loadAssignments = React.useCallback(() => {
    if (groupId) {
      setLoading(true);
      Api.assignment
        .getByGroup(groupId)
        .then((res) => {
          if (!hasError(res)) {
            setTraining(res?.data?.data ?? []);
          }
        })
        .finally(() => setLoading(false));
      Api.documents.getForGroup(groupId).then((res) => console.log(res));
    }
  }, [groupId]);

  React.useEffect(() => {
    loadAssignments();
  }, [loadAssignments]);

  React.useEffect(() => {
    if (groupId) {
      setLoading(true);
      Api.assignment
        .getByGroup(groupId)
        .then((res) => {
          if (!hasError(res)) {
            if (res.data.data) {
              setTraining(res.data.data);
            }
          }
        })
        .finally(() => setLoading(false));
      Api.documents.getForGroup(groupId).then((res) => console.log(res));
    }
  }, [groupId]);

  function moreHandler(menuItem: string, index: number, training: Training) {
    switch (menuItem) {
      case "Remove Assignment":
        getAssignments(training.trainingId);
        break;
    }
  }

  function getAssignments(trainingId: string) {
    setLoading(true);
    setTrainingId(trainingId)
    Api.assignment
      .getGroupAssignments(groupId, trainingId)
      .then((res) => {
        if (!hasError(res)) {
          console.log(res)
          if (res.data.data != null && res.data.data.length > 0) {
            setAssignmentIds(res.data.data)
            setShowDeleteConfirmation(true)
          } else {
            Api.assignment
              .deleteTrainingFromEmployeeGroup(groupId, trainingId)
              .then((res) => {
                if (!hasError(res)) {
                  enqueueSnackbar("Training removed successfully", {
                    variant: "success",
                  });
                }
              })
              .finally(() => {
                loadAssignments();
                setLoading(false);
              });
          }
        }
      })
      .finally(() => {
        loadAssignments();
        setLoading(false);
      });
  }

  function deleteAssignmentsAndTraining() {
    setShowDeleteConfirmation(false)
    setLoading(true);

    Api.assignment
      .deleteTrainingFromEmployeeGroup(groupId, trainingId)
      .then((res) => {
        if (!hasError(res)) {
          //if Not error found delete assignments
          Api.assignment.deleteAll(companyContext.companyId, assignmentIds, true)
            .then((res) => {
              if (!hasError(res)) {
                enqueueSnackbar("Assignments removed successfully", {
                  variant: "success",
                });
              }
            })
            .finally(() => {
              loadAssignments();
              setLoading(false);
            });
        }
      })
  }

  function deleteTraining() {
    setShowDeleteConfirmation(false)
    setLoading(true);
    Api.assignment
      .deleteTrainingFromEmployeeGroup(groupId, trainingId)
      .then((res) => {
        if (!hasError(res)) {
          enqueueSnackbar("Training removed successfully", {
            variant: "success",
          });
        }
      })
      .finally(() => {
        loadAssignments();
        setLoading(false);
      });
  }

  return (
    <div>
      <div className="datatable-container">
        <MaterialTable
          options={{
            selection: false,
            filtering: false,
            pageSize: 20,
          }}
          onRowClick={(event: any, training?: Training) => {
            if (training) {
              history.push(
                `/training/details/${training.trainingId}/${training.trainingVersion}`
              );
            }
          }}
          columns={[
            {
              title: "STATUS",
              field: "active",
              render: (rowData) =>
                !rowData.isParent ? (
                  <>
                    {rowData.active ? (
                      <Chip label="Active" color="primary" className="chip" />
                    ) : (
                      <Chip label="Inactive" className="chip" />
                    )}
                  </>
                ) : null,
            },
            {
              title: "TITLE",
              field: "trainingTitle",
              defaultSort: "asc",
              customSort: (a, b) =>
                a.trainingTitle
                  .toLocaleUpperCase()
                  .localeCompare(b.trainingTitle.toLocaleUpperCase()),
            },
            { title: "VERSION", field: "trainingVersion" },
            {
              title: "",
              cellStyle: { textAlign: "right", width: "48px" },
              field: "active",
              render: (rowData) => (
                <MoreButton
                  rowData={rowData}
                  menuItems={["Remove Assignment"]}
                  menuItemSelectedHandler={moreHandler}
                />
              ),
            },
          ]}
          data={training}
          components={{
            Toolbar: (props) => <TableSearch toolbarProps={props} />,
          }}
          isLoading={loading}
        />
      </div>
      <Dialog
        open={showDeleteConfirmation}
        onClose={() => { setShowDeleteConfirmation(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Warning
          <IconButton className={classes.customizedButton}>
            <CloseIcon onClick={() => { setShowDeleteConfirmation(false) }} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            We found {assignmentIds.length} assignment(s) associated with this training.
            Do you want to keep these assignments? or delete them?<br></br>
            <br></br>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => {
              deleteAssignmentsAndTraining()
            }}
          >
            Yes, delete assignments
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              deleteTraining()
            }}
            color="primary"
          >
            No, keep assignments
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
}

const useStyles = makeStyles({
  paper: {
    overflowY: 'unset',
  },
  customizedButton: {
    position: 'absolute',
    left: '92%',
    top: '2%'
  }
});